export function getUrlAndQuery(_url: any) {
  if (_url.indexOf("?") === -1) {
    return [_url, ""];
  }
  return [_url.substring(0, _url.indexOf("?")), _url.substring(_url.indexOf("?"))];
}
